import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-question-answer-line"></i>
            快速解答
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            关于香香漫画，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={`bg-background-50 border rounded-xl overflow-hidden transition-all ${
                  isOpen
                    ? 'border-primary-200/70'
                    : 'border-background-200/70'
                }`}
              >
                <button
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer"
                  onClick={() => setOpenId(isOpen ? -1 : faq.id)}
                >
                  <h3 className={`text-sm md:text-base font-semibold pr-4 font-heading ${
                    isOpen ? 'text-primary-600' : 'text-foreground-800'
                  }`}>
                    {faq.question}
                  </h3>
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${
                    isOpen
                      ? 'bg-primary-100 text-primary-500 rotate-45'
                      : 'bg-background-100 text-foreground-400'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <div className="pt-3 border-t border-background-200/70">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}